<template>
  <ubi-page-container class="SocialPostsList" wide-main-content>
    <template v-slot:page-actions>
      <social-posts-list-header v-if="hasSocialPostsAccess"></social-posts-list-header>
    </template>

    <confirm-delete-posts
      :modal-visible="modalVisible"
      :annonce="currentPost"
      v-on:close-modal-confirm-delete="closeModalDelete($event)"
      v-on:confirm-delete-posts="desactiverSelection($event)"></confirm-delete-posts>
    <confirm-delete-posts-b-v
      :modal-visible="modalVisible"
      :annonce="currentPost"
      v-on:close-modal-confirm-delete="closeModalDelete($event)"
      v-on:confirm-delete-posts="desactiverSelection($event)"></confirm-delete-posts-b-v>
    <confirm-delete-editorial-posts></confirm-delete-editorial-posts>

    <!-- Formulaires de recherche ApiSearchForm - les 3 sont chargés au démarrage, affichés selon l'onglet -->
    <template v-if="hasSocialPostsAccess">
      <!-- Formulaire Annonces -->
      <ApiSearchForm
        v-show="activeTab === 'Annonces'"
        :key="$route.fullPath + '-annonces'"
        route="socialnetwork-posts/annonces"
        :business-domain="businessDomain"
        :user-context="userContext"
        @search="handleSearchAnnonces"
        @reset="handleResetAnnonces"
      />

      <!-- Formulaire Biens Vendus (IMMO uniquement) -->
      <ApiSearchForm
        v-if="universe !== 'VO'"
        v-show="activeTab === 'BienVendus'"
        :key="$route.fullPath + '-biens-vendus'"
        route="socialnetwork-posts/biens-vendus"
        :business-domain="businessDomain"
        :user-context="userContext"
        @search="handleSearchBiensVendus"
        @reset="handleResetBiensVendus"
      />

      <!-- Formulaire Posts Éditoriaux -->
      <ApiSearchForm
        v-show="activeTab === 'PostsEditoriaux'"
        :key="$route.fullPath + '-editoriaux'"
        route="socialnetwork-posts/editoriaux"
        :business-domain="businessDomain"
        :user-context="userContext"
        @search="handleSearchEditoriaux"
        @reset="handleResetEditoriaux"
      />

      <social-posts-list-table
          :posts="socialNetworkPosts"
          :selected-posts-annonces="selectedPostsAnnonces"
          :selected-posts-b-v="selectedPostsBV"
          v-on:changetab="changeActiveTab($event)"
          v-on:show-modale-delete="showModalDelete($event)">
      </social-posts-list-table>
    </template>

    <ubi-panel v-else class="SocialPostsList-noSubscriptionPanel">
      <div class="SocialPostsList-noSubscription">
        <div class="SocialPostsList-noSubscription-image">
          <img
            :src="socialManagerIllustration"
            :alt="$t('layouts.socialManagment')"
          />
        </div>
        <div class="SocialPostsList-noSubscription-body">
          <div class="SocialPostsList-noSubscription-content" v-html="$t('socialPosts.list.noSubscription')"></div>
        </div>
      </div>
      <div class="SocialPostsList-noSubscription-action">
        <el-button type="primary" @click="submitLeadMail({ component: 'SocialPostsList' })">{{ $t('layouts.callbackFromAnAdvisor') }}</el-button>
      </div>
    </ubi-panel>
  </ubi-page-container>

</template>

<script>

import SocialPostsListHeader from './Blocks/SocialPostsListHeader'
import SocialPostsListTable from './Blocks/SocialPostsListTable'
import { mapMutations, mapState } from 'vuex'
import { fetchSocialPosts } from '../../services/posts'
import UbiPanel from '@/components/Panel'
import ConfirmDeletePosts from '@/pages/socialNetworks/Blocks/ConfirmDeletePosts'
import ConfirmDeletePostsBV from '@/pages/socialNetworks/Blocks/ConfirmDeletePostsBV'
import ConfirmDeleteEditorialPosts from '@/pages/socialNetworks/Blocks/ConfirmDeleteEditorialPosts'
import { diffusionAnnonceActivate, planificationsAnnonceActivate } from '@/services/portals'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import store from '@/store'
import UbiPageContainer from "@/components/PageContainer.vue";
import leadMailMixin from '@/mixins/leadMailMixin'

export default {
  name: 'SocialPostsList',
  mixins: [leadMailMixin],
  components: {
    UbiPageContainer,
    ConfirmDeletePostsBV,
    ConfirmDeletePosts,
    ConfirmDeleteEditorialPosts,
    UbiPanel,
    SocialPostsListHeader,
    SocialPostsListTable,
    ApiSearchForm
  },
  data () {
    return {
      modalVisible: false,
      currentPost: null,
      activeTab: 'Annonces',
      selectedPostsAnnonces: 0,
      selectedPostsBV: 0,
      socialManagerIllustration: require('@/assets/produits/Illustration-SM-2024.png'),
      socialNetworkPosts: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState('socialNetworkPosts', ['filter', 'results']),
    userRS () {
      return this.$store.getters.getUser.socialNetworkIds
    },
    universe () {
      return this.$store.getters.getSitimmoUser.univers
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    hasSocialPostsAccess () {
      return this.userRS.length > 0 && this.sitimmoUser.packSocialManagement
    },
    businessDomain () {
      return this.sitimmoUser.univers ? this.sitimmoUser.univers.toLowerCase() : 'immo'
    },
    userContext () {
      return {
        userId: this.sitimmoUser.id,
        univers: this.sitimmoUser.univers,
        metier: this.sitimmoUser.metier,
        activeTab: this.activeTab // Permet de basculer les champs selon l'onglet actif
      }
    }
  },
  mounted () {
    this.$store.commit('socialPostsCreationPostEditorial/setRedirection', false)
    this.$store.dispatch('promptLibraries/loadPrompts')
    this.$store.dispatch('promptLibraries/loadTonsIa')
    this.$store.dispatch('promptLibraries/loadListDataInitialByJob')
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'new-social-post' || to.name === 'edit-post-editorial' || to.name === 'manage-posts') {
      next()
    } else {
      this.$store.commit('socialNetworkPosts/setCurrentTab', 'Annonces')
      next()
    }
  },
  methods: {
    closeModalDelete (event) {
      this.modalVisible = false
    },
    search () {
      if (this.activeTab === 'Annonces') {
        this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
      } else if (this.activeTab === 'BienVendus') {
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
      } else {
        this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
      }
    },
    changeActiveTab (event) {
      this.activeTab = event
    },
    showModalDelete (event) {
      this.currentPost = event
      this.modalVisible = true
    },
    async desactiverSelection () {
      this.loading = true
      this.selectedPostsAnnonces = 1
      this.selectedPostsBV = 1
      let annonces = []
      const currentTab = this.$store.state.socialNetworkPosts.currentTab
      if (currentTab === 'Annonces') {
        this.$store.commit('socialPostsTableAnnonces/setLoadingStatus', true)
        annonces = this.$store.state.socialPostsTableAnnonces.postToDelete
      } else if (currentTab === 'BienVendus') {
        annonces = this.$store.state.socialPostsTableBiensVendus.postToDelete
        this.$store.commit('socialPostsTableBiensVendus/setLoadingStatus', true)
      }
      for (const annonce of annonces) {
        const tabJson = await this.generateTabJson(annonce)
        const arrayPlanifications = await this.generateArrayPlanifications(annonce)

        const response = await diffusionAnnonceActivate(tabJson)
        const self = this
        arrayPlanifications.forEach(function (planif) {
          this.$store.dispatch('calendarSocialPosts/deleteScheduled', [planif])
        }, self)
      }
      if (currentTab === 'Annonces') {
        this.$store.commit('socialPostsTableAnnonces/setModalDelete', false)
        this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
        this.$store.commit('socialPostsTableAnnonces/setLoadingStatus', false)
      } else if (currentTab === 'BienVendus') {
        this.$store.commit('socialPostsTableBiensVendus/setModalDelete', false)
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
        this.$store.commit('socialPostsTableBiensVendus/setLoadingStatus', false)
      } else {
        this.$store.commit('socialPostsTableBiensVendus/setModalDelete', false)
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
        this.$store.commit('socialPostsTableBiensVendus/setLoadingStatus', false)
      }
      this.selectedPostsAnnonces = 0
      this.selectedPostsBV = 0
    },
    async generateTabJson (annonce) {
      const tabJson = {}
      tabJson.diffusions = []
      const self = this
      if (annonce.diffusions && annonce.diffusions.length > 0) {
        annonce.diffusions.forEach(function (diffusion) {
          const codeName = this.searchCodename(diffusion.diffuseur)
          const tempTab = {}
          tempTab.diffuseur = codeName
          tempTab.annonce = annonce.id
          tempTab.activate = 0
          tabJson.diffusions.push(tempTab)
        }, self)
      }
      return tabJson
    },
    async generateArrayPlanifications (annonce) {
      const tabPlanif = []
      const self = this
      if (annonce.planifications && annonce.planifications.length > 0) {
        annonce.planifications.forEach(function (planification) {
          const tempTab = {}
          tempTab.id = planification.id
          tempTab.annonces = [annonce.id]
          tabPlanif.push(tempTab)
        }, self)
      }
      return tabPlanif
    },
    searchCodename (diffuseurId) {
      let codeName = ''
      store.getters.getUser.socialNetworkCodenames.forEach(function (diffusion) {
        if (diffusion[0] === diffuseurId) {
          codeName = diffusion[1]
        }
      })
      return codeName
    },
    doFilter (type) {
      switch (type) {
        case 'resetFromSearch':
          this.filter.search = ''
          this.setFilter(this.filter)
          break
      }
    },
    // === MÉTHODES POUR ApiSearchForm - Onglet Annonces ===
    handleSearchAnnonces (filters) {
      console.log('🔍 SocialPostsList - Filtres Annonces reçus:', filters)

      // Mapper le champ search vers le store de l'onglet Annonces
      if (filters.search !== undefined) {
        this.$store.commit('socialPostsTableAnnonces/setSearch', filters.search)
      }

      // Déclencher le chargement des posts Annonces
      this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
    },
    handleResetAnnonces () {
      console.log('🔄 SocialPostsList - Reset Annonces')
      this.$store.commit('socialPostsTableAnnonces/setSearch', '')
      this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
    },
    // === MÉTHODES POUR ApiSearchForm - Onglet Biens Vendus ===
    handleSearchBiensVendus (filters) {
      console.log('🔍 SocialPostsList - Filtres Biens Vendus reçus:', filters)

      // Mapper le champ search vers le store de l'onglet Biens Vendus
      if (filters.search !== undefined) {
        this.$store.commit('socialPostsTableBiensVendus/setSearch', filters.search)
      }

      // Déclencher le chargement des posts Biens Vendus
      this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
    },
    handleResetBiensVendus () {
      console.log('🔄 SocialPostsList - Reset Biens Vendus')
      this.$store.commit('socialPostsTableBiensVendus/setSearch', '')
      this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
    },
    // === MÉTHODES POUR ApiSearchForm - Onglet Posts Éditoriaux ===
    handleSearchEditoriaux (filters) {
      console.log('🔍 SocialPostsList - Filtres Posts Éditoriaux reçus:', filters)

      // Mapper le champ search vers le store de l'onglet Posts Éditoriaux
      if (filters.search !== undefined) {
        this.$store.commit('socialPostsTableEditoriaux/setSearch', filters.search)
      }

      // Déclencher le chargement des posts éditoriaux
      this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
    },
    handleResetEditoriaux () {
      console.log('🔄 SocialPostsList - Reset Posts Éditoriaux')
      this.$store.commit('socialPostsTableEditoriaux/setSearch', '')
      this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
    }
  }
}

</script>

<style lang="scss">
@import "../../theme/_bootstrap.scss";

.SocialPostsList {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }

  ::v-deep .el-card.Panel.SocialPostsList-noSubscriptionPanel .el-card__body {
    padding: 34px !important;
  }

  &-noSubscription {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 350px;
  }

  &-noSubscription-image {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    img {
      max-width: 250px;
      width: 100%;
      height: auto;
    }
  }

  &-noSubscription-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 20px;
  }

  &-noSubscription-content {
    width: 100%;
    text-align: left;

    h3 {
      margin-bottom: 1.5rem;
    }

    ul {
      margin: 1rem 0;
      padding-left: 1.5rem;
    }

    li {
      margin-bottom: 0.75rem;
    }
  }

  &-noSubscription-action {
    margin-top: 1.5rem;
    width: 100%;
    text-align: center;
  }

  @media (max-width: 768px) {
    &-noSubscription {
      flex-direction: column;
      min-height: auto;
    }

    &-noSubscription-image,
    &-noSubscription-body {
      width: 100%;
      padding: 15px;
    }
  }
}
</style>
